import { Lazy } from "fp-ts/lib/function";
import * as TE from "fp-ts/lib/TaskEither";
import toError from "to-error";

const teTryCatch = <T>(fn: Lazy<Promise<T>>): TE.TaskEither<Error, T> => {
  return TE.tryCatch(fn, toError);
};

export default teTryCatch;
